import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Navbar,
  Nav,
  Modal,
  Button,
  Form,
  Badge,
  Pill,
} from "react-bootstrap";
import Slider from "rc-slider";
import API from "API";
import styled from "styled-components";
import "rc-slider/assets/index.css";

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);

class PitchModal extends Component {
  state = {
    userPitch: "",
  };

  componentDidMount() {
    API.get(`/UserProfiles/${this.props.userToken.userId}`).then((response) =>
      this.setState(response.data)
    );
  }

  handleChange = (e) => {
    let { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleSubmit = () => {
    API.patch(`/UserProfiles/${this.props.userToken.userId}`, {
      userPitch: this.state.userPitch,
    }).then(() => {
      this.props.getFreshData();
      this.props.closeModal();
    });
  };

  render() {
    return (
      <Modal
        show={this.props.displayModal === "pitch"}
        size="lg"
        dialogClassName="modal-90w"
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Container>
            <ModalHeading>TMCF Pitch</ModalHeading>
            <p>
              When a recruiter opens your profile, the first thing they will see
              is your pitch. Please make sure it best reflects your interests
              and skills.
            </p>
            <Form>
              <Form.Row>
                <Col>
                  <Form.Label>Your pitch</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows="15"
                    placeholder="A summary of your achievements and previous success"
                    name="userPitch"
                    onChange={this.handleChange}
                    value={this.state.userPitch}
                  />
                </Col>
              </Form.Row>
              <Form.Row className="mt-2">
                <Button
                  className="  mr-1"
                  variant="outline-primary"
                  onClick={this.props.closeModal}
                >
                  Exit
                </Button>
                <Button className="ml-auto" onClick={this.handleSubmit}>
                  Update
                </Button>
              </Form.Row>
            </Form>
          </Container>
        </Modal.Body>
      </Modal>
    );
  }
}

export default PitchModal;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px;
`;

const ModalHeading = styled.h1``;
